import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import { Booking } from '../bookings/types';
import { BookingSelection } from './types';



interface MugshotsState {
  showModal: boolean;
  index: number | null;
  selectedBooking: Booking | null;
}

const initialState: MugshotsState = {
  showModal: false,
  index: null,
  selectedBooking: null,
}

export const mugshotsSlice = createSlice({
  name: 'mugshots',
  initialState,
  reducers: {
    selectBooking: (state, action: PayloadAction<BookingSelection>) => {
      state.selectedBooking = action.payload.booking
      state.index = action.payload.index
      state.showModal = true
    },
    closeModal: (state) => {
      state.showModal = false
      state.index = null
      state.selectedBooking = null
    },
  },
})

export const { selectBooking, closeModal } = mugshotsSlice.actions

export const selectSelectedBooking = (state: RootState) => state.mugshots.selectedBooking
export const selectSelectedBookingIndex = (state: RootState) => state.mugshots.index
export const selectShowModal = (state: RootState) => state.mugshots.showModal

export default mugshotsSlice.reducer